import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { authStoreSelector } from '../auth.selector';
import { ClientFeature } from '../feature.constant';

export const isFeatureEnabledSelector = createCachedSelector(
  [
    path(authStoreSelector).excludedScope(),
    prop<{ feature: ClientFeature }>().feature(),
  ],
  (excludedScope, feature): boolean => {
    return !(excludedScope ?? []).includes(feature);
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ feature: ClientFeature }>().feature(),
});
